import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
import Footer from '@/components/microsites/Footer.vue';
import Responsive from '@/services/browser/Responsive';
import '@/assets/scss/microsites/legacy/BlackHeaven/main.css';
import '@/assets/scss/microsites/legacy/BlackHeaven/chapters.css';
export default defineComponent({
  name: 'Microsite BlackHeaven',
  components: {
    Footer
  },
  mounted() {
    Responsive.init(); // is used for the vue footer

    this.$nextTick(() => {
      // main js is required to be loaded after the DOM was created
      let main = document.createElement('script');
      main.src = `${process.env.VUE_APP_ASSETS_URL}static/legacy/BlackHeaven/js/main.js`;
      main.defer = true;
      document.head.appendChild(main);
      window.dataLayer.push({
        pageType: 'Microsite',
        micrositeName: 'Black Heaven',
        micrositePhase: '1'
      });
    });
  }
});